import {InjectionToken} from '@angular/core';

/**
 * App-wide icon style for the shared components that ship both a Bootstrap/SVG and a FontAwesome
 * look (sortable table header, date-group calendar, true/false indicator). Set once per app:
 * `fontawesome` opts every such component into the legacy FontAwesome icons (ngwebbill); `default`
 * (or leaving the token unprovided) uses each component's native Bootstrap/SVG icons (other apps).
 *
 * Replaces the former per-component tokens (`SORTABLE_TABLE_HEADER_DEFAULTS`, the `iconStyle` field
 * of `INPUT_DATE_GROUP_DEFAULTS`, `TRUE_FALSE_DEFAULTS`). A subtree can override it with a
 * component-level provider (e.g. ngwebbill's accounting-data keeps the Bootstrap true/false icons
 * with `{iconStyle: 'default'}`).
 */
export const ICON_STYLE_DEFAULTS = new InjectionToken<{iconStyle: 'default' | 'fontawesome'}>(
    'ICON_STYLE_DEFAULTS',
);
